import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from "react-bootstrap";
import {withRouter} from "react-router";

class AdvertTypeModal extends Component {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        onHide: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {};

    render() {
        const props = this.props;
        return (
            <Modal {...props} className="modal-alert modal-info" bsSize="small">
                <Modal.Header>
                    <i className="fa fa-question-circle"/>
                </Modal.Header>
                <Modal.Body>
                    Вы хотите купить или продать поддоны?
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-primary"
                            onClick={() => this.navigateToBuy()}>
                        Купить
                    </button>
                    <button type="button" className="btn btn-danger"
                            onClick={() => this.navigateToSell()}>
                        Продать
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }

    navigateToBuy() {
        this.props.history.push('/adverts/create/buy');
        this.props.onHide();
    }

    navigateToSell() {
        this.props.history.push('/adverts/create/sell');
        this.props.onHide();
    }
}

export default withRouter(AdvertTypeModal);


// WEBPACK FOOTER //
// ./src/components/modals/AdvertTypeModal.js